'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../../../node_modules/classnames/index.js');
require('./Explore.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Explore = function (props) {
    var category = props.category, relatedPosts = props.relatedPosts, onBtnClick = props.onBtnClick, NextLink = props.NextLink, gtmClassName = props.gtmClassName;
    return (React__default['default'].createElement("div", { className: "explore" },
        React__default['default'].createElement("div", { className: "explore__title" }, category.name),
        React__default['default'].createElement("div", { className: "explore__description" }, category.description),
        React__default['default'].createElement("div", { className: "explore__lists" }, relatedPosts.map(function (post) {
            return NextLink ?
                React__default['default'].createElement(NextLink, { href: post.slug },
                    React__default['default'].createElement("a", { className: index['default']("explore__link", gtmClassName ? gtmClassName : ""), title: post.title, onClick: function () { return onBtnClick(); } }, post.title)) :
                React__default['default'].createElement("a", { className: index['default']("explore__link", gtmClassName ? gtmClassName : ""), href: post.slug, title: post.title, onClick: function () { return onBtnClick(); } }, post.title);
        }))));
};

exports.Explore = Explore;
//# sourceMappingURL=Explore.js.map
